module.exports = __webpack_public_path__ + "img/7.cc4c0eb7.png";